module.exports = "https://cdn.hellotech.com/client-assets/linkedin_621f9d1fbdf4b509dcc597a3a11661cf.svg";